var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCarParking = function SvgCarParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CarParking_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".CarParking_svg__st0{fill:#262a30}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CarParking_svg__Group",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "CarParking_svg__st0",
    d: "M22.5 41C12.3 41 4 32.7 4 22.5S12.3 4 22.5 4 41 12.3 41 22.5 32.7 41 22.5 41zm0-35C13.4 6 6 13.4 6 22.5S13.4 39 22.5 39 39 31.6 39 22.5 31.6 6 22.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CarParking_svg__P",
    className: "CarParking_svg__st0",
    d: "M21.3 22.1h1.8c2 0 3-.9 3-2.8s-1-2.8-3-2.8h-1.8v5.6zm.1 12.2h-5.8V11.5h9.3c2.5 0 4.5.7 5.8 2s2 3.2 2 5.6-.7 4.3-2 5.6c-1.3 1.3-3.3 2-5.8 2h-3.5v7.6z"
  }))));
};
export default SvgCarParking;